import { render, staticRenderFns } from "./AddCommune.vue?vue&type=template&id=0603c23e&"
import script from "./AddCommune.vue?vue&type=script&lang=js&"
export * from "./AddCommune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports